import type { SellerProductDetailView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";

export function fetchSellerProductById(productId: string) {
  return apiJsonClient<SellerProductDetailView>(
    endpoints.seller.productById(productId),
  );
}
